import React from 'react';
import { useTranslation } from 'react-i18next';

const StepByStepB = () => {
  const { t } = useTranslation();

  return (
    <div id="timeline" className="pt-20 pb-10 bg-white">
      
      <p className="text-center uppercase text-md">{t('Boekhouders.StepByStepB.Subtitle')}</p>
      <h2 className="text-4xl font-bold text-center md:text-5xl">{t('Boekhouders.StepByStepB.Title')}</h2>
      
      <hr className="block w-12 h-1 mx-auto mt-4 mb-6 border-0 outline-0 bg-legoOrange" />
      
      <h1 className="pt-10 mb-5 text-2xl font-bold text-center md:text-3xl">{t('Boekhouders.StepByStepB.Title2')}</h1>
      <p className="text-center max-w-[1000px] mx-auto mb-10 container">
        {t('Boekhouders.StepByStepB.Subtitle2')}
      </p>

      <h2 className="pt-10 mb-5 text-2xl font-bold text-center md:text-3xl">{t('how-active-customer.Een uitdager voor de klassieke boekhouding')}</h2>
      <p className="text-center max-w-[1000px] mx-auto mb-10 container">{t('how-active-customer.Hoewel Peppol een uitdager wordt voor de klassieke boekhouding')}</p>

      <h2 className="pt-10 mb-5 text-2xl font-bold text-center md:text-3xl">{t('how-active-customer.Kies voor onze partneroplossing')}</h2>
      <p className="text-center max-w-[1000px] mx-auto mb-10 container">{t('how-active-customer.Als boekhoud- en accountancykantoor kan je voor jouw')}</p>

      <div className='container my-16'>
        <div className='p-6 mb-6 bg-legoOrange'>
          <p className='text-center text-white'>{t('how-active-customer.Kant-en-klaar')}</p>
        </div>

        <h2 className="pt-10 mb-5 text-2xl font-bold text-center md:text-3xl">{t('how-active-customer.Hoe gaat het in zijn werk')}</h2>
        <div className='flex justify-center'>
          <img src={'/images/schema-peppol-integration.png'} alt="Schema peppol integratie" />
        </div>
      </div>

      <div className='container flex flex-col w-full gap-8'>
        <h2 className="text-2xl font-bold text-center md:text-3xl">{t('how-active-customer.Hoe jouw klant op Peppol activeren')}</h2>
        <div className='grid gap-10 md:grid-cols-4 md:gap-16'>
          <div className='flex flex-col items-start col-start-1 gap-6 md:flex-row col-span-full'>
            <p className='text-6xl font-bold text-legoOrange'>01</p>
            <div className='p-6 rounded-lg bg-legoOrange/10'>
              <p className='max-w-3xl font-medium'>{t('how-active-customer.Ga na of jouw eindklant reeds actief is op Peppol')}</p>
            </div>
          </div>
          <div className='flex flex-col items-start col-start-2 gap-6 md:flex-row col-span-full'>
            <p className='text-6xl font-bold text-legoOrange'>02</p>
            <div className='p-6 rounded-lg bg-legoOrange/10'>
              <p className='max-w-3xl font-medium'>{t('how-active-customer.Via onze kanalen kan je de nodige informatie doorgeven')}</p>
            </div>
          </div>
          <div className='flex flex-col items-start col-start-1 gap-6 md:flex-row col-span-full'>
            <p className='text-6xl font-bold text-legoOrange'>03</p>
            <div className='p-6 rounded-lg bg-legoOrange/10'>
              <p className='max-w-3xl font-medium'>{t('how-active-customer.Wij registeren de eindklanten voor jou op het Peppol-netwerk')}</p>
            </div>
          </div>
          <div className='flex flex-col items-start col-start-2 gap-6 md:flex-row col-span-full'>
            <p className='text-6xl font-bold text-legoOrange'>04</p>
            <div className='p-6 rounded-lg bg-legoOrange/10'>
              <p className='max-w-3xl font-medium'>{t('how-active-customer.Klant is volledig klaar voor Peppol')}</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* <div className="container grid grid-cols-1 gap-8 md:grid-cols-2">
        {[
          { title: t('Boekhouders.StepByStepB.CardTitle1'), text: t('Boekhouders.StepByStepB.CardSubtitle1') },
          { title: t('Boekhouders.StepByStepB.CardTitle2'), text: t('Boekhouders.StepByStepB.CardSubtitle2') },
          { title: t('Boekhouders.StepByStepB.CardTitle3'), text: t('Boekhouders.StepByStepB.CardSubtitle3') },
          { title: t('Boekhouders.StepByStepB.CardTitle4'), text: t('Boekhouders.StepByStepB.CardSubtitle4') }
        ].map((step, index) => (
          <div key={index} className="p-6 bg-white rounded-lg shadow-2xl rounded-t-md">
            <div className="flex items-center mb-4">
              <div className="flex items-center justify-center w-12 h-12 mr-4 text-lg font-bold bg-legoOrange/10">{index + 1}</div>
              <h2 className="text-lg font-semibold">{step.title}</h2>
            </div>
            <p className="text-sm">{step.text}</p>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default StepByStepB;
